"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirectReducer = (state, payload) => {
    return Object.assign({}, state, { redirect: {
            url: payload.url,
            status: payload.status,
        } });
};
